// extracted by mini-css-extract-plugin
module.exports = {"container":"Complete_container__9NwZm","score":"Complete_score__VYoyn"};